import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 23"
      fill="none"
    >
      <path
        d="M43.3261 22.2074L39.9305 16.0443H38.977V22.2074H35V5.88086H41.6748C42.9617 5.88086 44.0548 6.10568 44.9541 6.55532C45.8689 7.00496 46.5511 7.62515 47.0007 8.41589C47.4504 9.19113 47.6752 10.0594 47.6752 11.0207C47.6752 12.106 47.3651 13.0751 46.7449 13.9278C46.1402 14.7806 45.2409 15.3853 44.0471 15.7419L47.8147 22.2074H43.3261ZM38.977 13.2301H41.4422C42.171 13.2301 42.7136 13.0518 43.0702 12.6952C43.4424 12.3386 43.6284 11.8347 43.6284 11.1835C43.6284 10.5633 43.4424 10.0749 43.0702 9.7183C42.7136 9.36169 42.171 9.18338 41.4422 9.18338H38.977V13.2301Z"
        fill="white"
      />
      <path
        d="M49.3948 19.3689C49.9017 18.9664 50.1328 18.78 50.0881 18.8098C51.5491 17.6022 52.697 16.6108 53.5319 15.8356C54.3817 15.0603 55.0973 14.2478 55.6787 13.398C56.2602 12.5483 56.5509 11.7208 56.5509 10.9158C56.5509 10.3045 56.4093 9.82746 56.126 9.48457C55.8427 9.14167 55.4178 8.97023 54.8513 8.97023C54.2848 8.97023 53.8375 9.1864 53.5096 9.61875C53.1965 10.0362 53.0399 10.6325 53.0399 11.4078H49.3501C49.3799 10.1405 49.6483 9.08204 50.1552 8.23226C50.677 7.38248 51.3553 6.75632 52.1902 6.35379C53.0399 5.95126 53.9792 5.75 55.0079 5.75C56.782 5.75 58.1163 6.20471 59.0108 7.11412C59.9202 8.02354 60.3749 9.20876 60.3749 10.6698C60.3749 12.265 59.8307 13.7484 58.7424 15.12C57.6541 16.4766 56.2676 17.8035 54.583 19.1005H60.6209V22.2089H49.3948V19.3689Z"
        fill="white"
      />
      <circle cx="4.10713" cy="11.5002" r="4.10713" fill="white" />
      <circle cx="11.4316" cy="18.8928" r="4.10713" fill="white" />
      <circle cx="18.8242" cy="11.5002" r="4.10713" fill="white" />
      <circle cx="26.3403" cy="4.10713" r="4.10713" fill="white" />
    </svg>
  );
};

export default LogoFull;
